export default "__VITE_ASSET__KkEhP_5a__"